import TemplateView from '../../../TemplateView'

export default class SettingsInfoContainer extends TemplateView {
    constructor({
        content
    }) {
        super()

        this.content = content

        this.state = {
            collapsed: false,
        }

        this.onStatePropertyChanged("collapsed", (collapsed) => {
            this.$el.toggleClass("hiddenBlock", collapsed)
        })
    }

    templateHtml() {
        return '<div class="settingsInfoContainer collapsibleBlock">' +
               '  <div class="pointer"></div>' +
               '  <div class="contentPlaceholder"></div>' +
               '</div>'
    }

    afterRender() {
        this.content.init(this.find(".contentPlaceholder"))
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/darSettings/components/SettingsInfoContainer.js